import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CustomerOmnisearchResultsService } from '../../../../customer/search/customer-omnisearch-results.service';
import { BaseComponent } from '../../../base-components/base.component';
import { Dictionary } from '../../../models/dictionary.model';
import { ActionTopic } from '../../../services/dispatcher/action-topic.enum';
import { MessageKeys } from '../../../services/dispatcher/message-keys';

@Component({
    selector: 'navbar-search',
    templateUrl: './navbar-search.component.html'
})
export class NavbarSearchComponent extends BaseComponent {
    @Input() routerUrl: string;
    @Output() onNavigateRequest = new EventEmitter<any>();

    public commonSearchString: string;
    public isCustomerSelected = true;
    private vehicleSearchString = '';

    constructor(private searchResultService: CustomerOmnisearchResultsService) {
        super();
    }

    ngOnInit() {}

    advancedSearch() {
        this.navigate(['customer', 'loading', 'search']);
    }

    customerReceiveResults(results) {
        this.resetCommonSearch();

        if (results && results.length == 1) {
            this.navigate(['customer', 'loading', results[0].customerNumber, results[0].customerTypeId]);
        } else if (results && results.length > 1) {
            // Navigate to Advanced Search, populating results
            this.searchResultService.setResults(results);
            this.advancedSearch();
        }
    }

    resetCommonSearch() {
        this.commonSearchString = '';
    }

    searchSelected(customerSelected: boolean) {
        this.isCustomerSelected = customerSelected;
    }

    searchStringChanged(searchString: string) {
        this.commonSearchString = searchString;
    }

    vehicleReceiveResults(results) {
        this.resetCommonSearch();
        const resultStringyfy = JSON.stringify(results);

        if (this.routerUrl.startsWith('/customer/search')) {
            const searchValues: Dictionary = new Dictionary([]);

            searchValues.add(MessageKeys.SearchResults, resultStringyfy);
            searchValues.add(MessageKeys.SearchParameters, this.vehicleSearchString);
            this.dispatcher.publish({ topic: ActionTopic.SearchResultsReturned, values: searchValues});
        } else {
            const commands = ['customer', 'search'];
            const options = { queryParams: { 'results': resultStringyfy, 'searchString': this.vehicleSearchString }, skipLocationChange: true };
            this.navigate(commands, options);
        }
    }

    vehicleSearchStringUsed(searchString) {
        this.vehicleSearchString = searchString;
    }

    private navigate(commands: any[], options: any = undefined) {
        const navRequest = options ? { commands: commands, options: options } : { commands: commands };
        this.onNavigateRequest.emit(navRequest);
    }
}
